module.exports = __webpack_public_path__ + "assets/media/level3-user-icon.4dd5bd73.png";